/* ===== engine/platform/dynres.ts — 동적 해상도: 프레임이 늦으면 그리는 화소를 줄이고, 여유가 생기면 되돌린다 ===== */
/* Unreal 의 동적 해상도 · Godot 의 3D 배율처럼 화면(캔버스) 화소 밀도를 [min, max] 안에서 움직인다. 소프트웨어 그리기에서는 프레임 비용이
   화소 수에 거의 비례한다(1600×900 한 장 덮기 ≈ 0.5~5ms) — 밀도를 0.85 배 줄이면 화소가 28% 준다.
   ★ 갈아 끼우기는 드물게 — 캔버스 크기를 바꾸면 버퍼를 새로 잡는다. 1초 평균으로 재고, 내릴 때는 바로 · 올릴 때는 여유가 3초 이어져야 하며,
   올렸다가 다시 늦어지면 다음 올리기를 두 배 늦춘다(오르내림 진동 방지). 스크립트가 느린 것(CPU)은 화소를 줄여도 안 낫는다 — 그때는 안 내린다. */

export interface DynResOpts { min: number; max: number; budget: number; step?: number }

export class DynRes {
  declare o: Required<DynResOpts>; declare scale: number; declare acc: number; declare js: number; declare n: number; declare t: number;
  declare good: number; declare hold: number; declare upAt: number;
  constructor(o: DynResOpts) { this.o = { step: 0.85, ...o }; this.scale = o.max; this.acc = 0; this.js = 0; this.n = 0; this.t = 0; this.good = 0; this.hold = 3; this.upAt = -1; }
  /** 범위 · 목표를 바꾼다(설정이 바뀜) — 지금 배율은 새 범위 안으로 */
  set(o: DynResOpts): void {
    this.o = { step: 0.85, ...o };
    if (this.scale > o.max || this.scale < o.min) this.scale = Math.min(o.max, Math.max(o.min, this.scale));
  }
  /** 한 프레임 — period: 앞 프레임과의 간격(초) · jsMs: 이 프레임 스크립트 시간(ms). 배율이 바뀌었으면 true */
  frame(period: number, jsMs: number, now: number): boolean {
    if (!(period > 0) || period > 0.25) return false;          // 탭을 내렸다 올림 · 멈춤 — 재지 않는다
    this.acc += period; this.js += jsMs / 1000; this.n++;
    if (now - this.t < 1) return false;
    const P = this.acc / this.n, J = this.js / this.n, B = this.o.budget;
    this.acc = this.js = 0; this.n = 0; this.t = now;
    const old = this.scale;
    if (P > B * 1.2 && J < P * 0.7) {                          // 늦고, 스크립트 탓이 아니다 — 그리기가 무겁다
      if (this.upAt >= 0 && now - this.upAt < 4) this.hold = Math.min(60, this.hold * 2);   // 막 올렸는데 늦어졌다
      this.upAt = -1; this.good = 0;
      this.scale = Math.max(this.o.min, this.scale * this.o.step);
    } else if (P < B * 1.08 && J < B * 0.5) {
      if (++this.good >= this.hold && this.scale < this.o.max) { this.scale = Math.min(this.o.max, this.scale / this.o.step); this.good = 0; this.upAt = now; }
    } else this.good = 0;
    if (Math.abs(this.scale - this.o.max) < 0.02) this.scale = this.o.max;
    return this.scale !== old;
  }
}
